import { Flex } from "antd";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../components/common/Loading";
import { useGetMyStationeryRequest } from "../../query/HrmQuery";
import { notify } from "../../utils/toast";
import NotFound from "../NotFound/NotFound";
import PersonalStationeryItems from "./PersonalStationeryItems";
import PersonalStationeryRequest from "./PersonalStationeryRequest";
import { Status } from "../../enum/common";

const PersonalStationeryDetail = () => {
  const { alias } = useParams();
  const periodId = Number(alias);
  const { data, isLoading } = useGetMyStationeryRequest(periodId);
  const navigate = useNavigate();

  useEffect(() => {
    if (data?.period.approvalStatus === Status.REJECTED) {
      notify.warning("Kỳ mua văn phòng phẩm này đã bị từ chối");
      navigate(-1);
    }
  }, [data?.period.approvalStatus, navigate]);
  if (!alias) {
    return <NotFound />;
  }

  if (isLoading) {
    return <Loading show={true} />;
  }

  const hasRequest = !!data;

  return (
    <Flex justify="center" className="w-full mt-2">
      {hasRequest ? (
        <PersonalStationeryItems data={data} />
      ) : (
        <PersonalStationeryRequest stationeryId={periodId} />
      )}
    </Flex>
  );
};
export default PersonalStationeryDetail;
